import {Component, OnInit, ViewChild} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {IonSlides, ModalController, NavController, Platform} from '@ionic/angular';
import {Router} from '@angular/router';
import {LandingComponent} from '../landing/landing.component';

@Component({
  selector: 'app-on-boarding',
  templateUrl: './on-boarding.component.html',
  styleUrls: ['./on-boarding.component.scss'],
})
export class OnBoardingComponent implements OnInit {
  @ViewChild('slider') slider: IonSlides;
  slides: Array<{ title: string; description: string; image: string }> = [];
  currentIndex = 0;
  slideOpts = {
    allowTouchMove: true,
    initialSlide: 0,
    pager: true,
    speed: 1000
  };

  constructor(public translate: TranslateService,
              private platform: Platform,
              private modalController: ModalController,
              private navController: NavController,
              private router: Router) {
  }

  ngOnInit() {
    this.platform.ready().then(() => {
      this.initializeTranslation();
    });
  }

  initializeTranslation() {
    this.translate.get(['on_boarding']).subscribe(
      (values) => {
        this.slides = [
          {
            title: values.on_boarding.screen1_title,
            description: values.on_boarding.screen1_desc,
            image: 'assets/img/logo/LOGO-MA.svg',
          },
          {
            title: values.on_boarding.screen2_title,
            description: values.on_boarding.screen2_desc,
            image: 'assets/img/logo/LOGO-PI.svg',
          },
          {
            title: values.on_boarding.screen3_title,
            description: values.on_boarding.screen3_desc,
            image: 'assets/img/logo/LOGO-MO.svg',
          }
        ];
      });
  }

  sliderChange(e: any) {
    this.slider.getActiveIndex().then((index: number) => {
      this.currentIndex = index;
    });
  }

  slidePrev() {
    this.slider.slidePrev();
  }

  slideNext() {
    this.slider.slideNext();
  }

  async landing() {
    this.router.navigate(['/landing-preview']);
    /*const modal = await this.modalController.create({
      component: LandingComponent,
      componentProps: {
        selectProjectMap: true
      },
      cssClass: 'custom-modal',
      showBackdrop: true,
      backdropDismiss: true
    });

    modal.onDidDismiss()
      .then((data: any) => {
        if (data.data) {
          localStorage.setItem('projectType', data.data.type);
          if (['ap', 'act', 'space'].indexOf(data.data.type) > -1) {
            this.router.navigate(['/map']);
          } else {
            this.router.navigate(['project', data.data.type]);
          }
          // this.project = data.data;
        }
      });
    return await modal.present();*/
  }
}
